// removed by extract-text-webpack-plugin
module.exports = {"editHeader":"_2EsTk JmZU_ _38618 _3Dqep","editHeaderButtons":"_3xwd3 VW9bs","editHeaderButton":"_34R76","saveButton":"_2jdvQ _34R76","cancelButton":"_1swfk _34R76"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/EditHeader.css
// module id = 2223
// module chunks = 3